module.exports = __webpack_public_path__ + "img/tel.dc773daa.jpg";